import { DynamicComponentProps } from "@/types/ModuleComponentProp.type"
import React from "react"
import styles from './InspectionClosure.module.scss';
import { useTranslation } from 'react-i18next';
import { RootState } from "@/store/rootReducer";
import { useSelector } from "react-redux";
import { DecimalInput } from "@/components/DecimalInput";
import { APP_CONFIG_KEY } from "@/types/AppConfig.type";

export const InspectionClosure: React.FC<DynamicComponentProps> = ({ inspection, onValueChange }: DynamicComponentProps) => {
    const { t: translate } = useTranslation()
    const inspectorCommentLength = useSelector((state: RootState) => state.appConfig[APP_CONFIG_KEY.inspectorCommentLength] || 1000);
    const [removedQuantityError, setRemovedQuantityError] = React.useState<string | undefined>(undefined);

    const handleDecimalChange = (event: { target: { name: string; value: number | null } }) => {
        if (event.target.name === 'removedQuantity') {
            const sampleSize = inspection?.sampleSize;
            if (
                typeof sampleSize === 'number' &&
                typeof event.target.value === 'number' &&
                event.target.value > sampleSize
            ) {
                setRemovedQuantityError(translate('Removed Quantity cannot be greater than Sample Size'));
            } else {
                setRemovedQuantityError(undefined);
            }
        }

        if (onValueChange) {
            onValueChange(event as any);
        }
    };

    return (
        <div className={styles.formContainer}>
            <div className={styles.inputRow}>
                <div className={styles.inputGroup}>
                    {removedQuantityError && <p className={styles.validationError}>{removedQuantityError}</p>}
                    <DecimalInput
                        id="removedQuantity"
                        name="removedQuantity"
                        value={inspection?.removedQuantity}
                        onChange={handleDecimalChange}
                        label={translate('Removed Quantity')}
                    />
                </div>
            </div>
            <div className={styles.inputGroup}>
                <label className={styles.lable} htmlFor="inspectorComment">{translate('Inspection Comment')}</label>
                <textarea id="inspectorComment" maxLength={inspectorCommentLength} name='inspectorComment' rows={4}
                    value={inspection?.inspectorComment || ''} onChange={onValueChange}></textarea>
            </div>
        </div>
    );
}